export default {
    methods: {
        checkForPermission(permission){
            const userPermissions = JSON.parse(localStorage.getItem('userPermissions'));
            let access = false;
            if (permission){
                access = userPermissions.some( p => p.includes(permission));
            }
            return access
        }
    }
}
